define(['text!./templates/quote-offering.html'],
    (templateStr) => {
        return [()=> {
            return {
                restrict: 'A',
                template: templateStr,
                scope: {
                    quote: '=gwQnbQuoteOffering',
                    buy: '&',
                    nextSteps: '&',
                    header:'@',
                    biLimits:'@',
                    lob:'@'
                }
            };
        }];
    }
);



/** WEBPACK FOOTER **
 ** ./common/js/src/integration/quoteandbind/directives/QuoteOffering.js
 **/